import { useCallback, useState } from 'react';

import { backupSettingsClient, levelValue, OrderBackups } from '../api';
import { useBackupChoice, useBackupSave } from '../hooks';

import BackupsSetting from './BackupsSetting';
import { backupSavedToast } from './toast';

import SurgeToast, {
  SurgeToastMessage,
} from '@/routes/Agency/PaySurge/components/SurgeToast';

const useSavedToast = () => {
  const [toast, setToast] = useState<SurgeToastMessage | null>(null);
  const dismiss = useCallback(() => setToast(null), []);
  return {
    toast,
    setToast,
    node: <SurgeToast toast={toast} onDismiss={dismiss} />,
  };
};

/** The order's own setting, in the Order page's Summary card. */
export const OrderBackupsSetting = ({ order }: { order: OrderBackups }) => {
  const { setToast, node } = useSavedToast();
  const { save, saving, error } = useBackupSave(
    (enabled) => backupSettingsClient.setOrder(order.order_id, enabled),
    'Could not save auto backups for this order. Please try again.',
    (saved, enabled) =>
      setToast(
        backupSavedToast(
          'order',
          enabled,
          saved.enabled ?? saved.client_enabled,
        ),
      ),
  );
  const chooser = useBackupChoice(save);

  return (
    <>
      <BackupsSetting
        level="order"
        label="Auto backups for this order"
        {...levelValue('order', {
          order: order.enabled,
          client: order.client_enabled,
        })}
        switchOn={order.switch_on}
        saving={saving}
        error={error}
        chooser={chooser}
        testId="order-backups"
      />
      {node}
    </>
  );
};
